document.addEventListener('DOMContentLoaded', () => {
    const copyOpeningTimes = (() => {
        // Get the times from Monday
        const sourceOpenInput = document.getElementById('hours_monday_open');
        const sourceClosedInput = document.getElementById('hours_monday_closed');
        const copyButton = document.getElementById('copy_times');
        const days = [
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
            'sunday'
        ];

        // Event listener for the copy button click
        copyButton.addEventListener('click', () => {
            const openValue = sourceOpenInput.value;
            const closedValue = sourceClosedInput.value;

            // Loop through the days and update the times
            days.forEach((day) => {
                const dayActiveCheckbox = document.getElementById('hours_' + day + '_active');
                const dayOpenInput = document.getElementById('hours_' + day + '_open');
                const dayClosedInput = document.getElementById('hours_' + day + '_closed');

                if (dayActiveCheckbox.checked) {
                    dayOpenInput.value = openValue;
                    dayClosedInput.value = closedValue;
                }
            });
        });
    })();
});
